<template>
    <div class="page-content">
        <div class="page-top">
            <div class="page-top-content">
                <el-form inline label-position="top">
                    <el-form-item label="类型">
                        <el-select filterable v-model="searchForm.type_id">
                            <el-option v-for="(item,index) in typeList"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-select filterable v-model="searchForm.order_by">
                            <el-option v-for="(item,index) in sortList"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="地区">
                        <el-select filterable v-model="searchForm.area_id">
                            <el-option label="全部区域" :value="0"></el-option>
                            <el-option v-for="(item,index) in cityList"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 50px;">
                        <el-button type="primary" @click="handlerSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page-body">
            <div class="page-body-left">
                <CouponItem v-for="(item,index) in list" :key="index" :item="item"></CouponItem>
                <el-alert v-if="list.length<=0" title="暂无数据~" center :closable="false" type="warning" show-icon></el-alert>
            </div>
            <div class="page-body-right">
                <div class="right-title">我的折扣券</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import CouponItem from "../components/CouponItem";

    export default {
        name: "coupon",
        components:{CouponItem},
        data() {
            return {
                searchForm: {
                    page: 1,
                    area_id: 0,
                    type_id: 0,
                    order_by: 0
                },
                typeList: [
                    {id: 0, name: '全部'},
                    {id: 1, name: '折扣券'},
                    {id: 2, name: '现金券'}
                ],
                sortList: [
                    {id: 0, name: '高价优先'},
                    {id: 1, name: '低价优先'}
                ],
                list: [],
                finish: false
            }
        },
        computed: {
            ...mapState(['cityList'])
        },
        created() {
            this.getCoupon()
            this.$eventBus.$on('onBottom', this.handlerBottom)
        },
        methods: {
            handlerSearch() {
                this.searchForm.page = 1;
                this.getCoupon()
            },
            async getCoupon(){
                let [e, data] = await this.$api.getCouponApi(this.searchForm)
                if(this.searchForm.page === 1){
                    this.list = data.result;
                }else {
                    this.list = [...this.list, ...data.result]
                }
                this.finish = data.result.length <= 0;
            },
            handlerBottom(){
                if (this.finish) return;
                this.searchForm.page++;
                this.getCoupon();
            }
        },
    }
</script>

<style scoped lang="less">
    .page-top {
        width: 100%;
        background-color: #ffffff;
        position: sticky;
        top: 80px;
        left: 0;
        z-index: 9;
        border-bottom: 1px solid #e2e2e2;

        .page-top-content {
            width: 1200px;
            margin: auto;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
    }
    .page-body{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 1200px;
        margin: auto;
        padding: 20px;
        .page-body-left{
            width: 900px;
            padding: 20px;
            box-sizing: border-box;
            margin-right: 20px;
            box-shadow: 3px 3px 6px #A6A6A6;
            background-color: #ffffff;
        }
        .page-body-right{
            flex: 1;
            padding: 20px;
            box-sizing: border-box;
            box-shadow: 3px 3px 6px #A6A6A6;
            background-color: #ffffff;
        }
    }
</style>
